import { render, staticRenderFns } from "./BCXFormField.vue?vue&type=template&id=e5449d76&scoped=true"
import script from "./BCXFormField.vue?vue&type=script&lang=ts&setup=true"
export * from "./BCXFormField.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./BCXFormField.vue?vue&type=style&index=0&id=e5449d76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5449d76",
  null
  
)

export default component.exports